import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const OriginStoreCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Origin store", cell: (row) => row.originStore || "" };
